import NavLink from "../shared/NavLink";

const FooterLinks = () => {
  return (
    <div>
      <div className="flex flex-col gap-4 sm:gap-6">
        <NavLink
          href="https://www.instagram.com/divno_or/"
          text="Instagram"
          textClassName="text-white font-poppins tracking-tighter text-sm sm:text-base md:text-lg"
          target="_blank"
          rel="noopener noreferrer"
        />
        <NavLink
          href="https://www.linkedin.com/in/divnoor-singh-nagra/"
          text="LinkedIn"
          textClassName="text-white font-poppins tracking-tighter text-sm sm:text-base md:text-lg"
          target="_blank"
          rel="noopener noreferrer"
        />
        <NavLink
          href="mailto:divnoorsinghnagra@gmail.com"
          text="Mail"
          textClassName="text-white font-poppins tracking-tighter text-sm sm:text-base md:text-lg"
        />
      </div>
      <div className="text-primary font-poppins tracking-tighter mt-[40px] sm:mt-[56px] font-semibold text-sm sm:text-base md:text-lg">
        Vancouver
      </div>
    </div>
  );
};

export default FooterLinks;
